import sitemapData from '../../data/siteMapData/siteMap.json'

export async function getContentfulData() {
    return sitemapData;
  }